import * as React from 'react';

import Modal from 'react-modal';
import { Button } from 'react-bootstrap';

import { translateService } from '../../services/TranslateService';
import { ResponseModalStruct } from '../../interfaces/ModalStructs';

import './ResponseModal.scss';

interface ResponseModalProps {
    response?: ResponseModalStruct;
    closeFunc: (redirect: string | undefined) => void;
}

const customStyles = {
    content: {
        width: '90%',
        maxWidth: '1000px',
        maxHeight: '95%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
        scroll: 'auto'
    },
    overlay: {
        zIndex: '100',
    },
};

const ResponseModal: React.FC<ResponseModalProps> = (props: any) => {
    Modal.setAppElement('body');

    let responseclass = 'response-text';
    if (props.response && props.response.justify && props.response.justify === 'left') {
        responseclass = 'response-text response-text-left';
    }

    return (
        <Modal isOpen={!!props.response} style={customStyles} contentLabel='Response Modal'>
            <div className={responseclass}>
                {props.response && props.response.html ?
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.response ? props.response.html : '',
                        }}
                    /> : props.response?.text ? props.response.text : props.response}

            </div>
            <div className='response-button'>
                <Button
                    className='mt-3'
                    color='primary'
                    onClick={() => {
                        if(props.response.scrollToTop) {
                            setTimeout(() => {
                                document.getElementById('check-available-times')?.scrollIntoView({
                                    behavior: 'smooth',block: 'center'})
                            }, 0);
                        }
                        props.closeFunc(props.response && props.response.redirect)}} >
                    {props.response
                        ? props.response.buttonText
                            ? props.response.buttonText
                            : translateService.translate('globalTexts.ok')
                        : undefined}
                </Button>
            </div>

        </Modal>
    );
};
export default ResponseModal;
